<template>
  <div>
    <label :for="name">{{ name }}:</label>
    <input
      type="range"
      :id="name"
      :min="modulador.min"
      :max="modulador.max"
      :value="modulador.value"
      @input="updateValue($event.target.value)"
    />
    <p>{{ name }} value: {{ modulador.value }}</p>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  name: String,
  modulador: Object
});

const emits = defineEmits(['update:value']);

const updateValue = (newValue) => {
  emits('update:value', { name: props.name, value: newValue });
};
</script>
  